import $ from 'jquery'
import globalEventBus from 'toxilibs/event_bus_queued.js'
import googleAnalytics from 'toxilibs/gtag.js'
import challengesNavigator from './challenges_navigator.js'
import config from './stats_config.js'
import developmentEnvironment from './development_environment.js'

let eventBus = globalEventBus('stats')

eventBus.on('challenge loaded', challengeStarted)
eventBus.on('step completed', challengeWin)
eventBus.on('game ended', gameEnded)
eventBus.on('challenge loose', challengeLose)
eventBus.on('player moved', registerPlayerMove)
eventBus.on('player won', sendChallengeCompleted)
eventBus.on('wrong way taken', sendWrongWayTaken)



globalEventBus.on('wrong way taken', function (stepCount) {
    globalEventBus.emit('challenge loose', challengesNavigator.current.id, stepCount) //For Analytics
})


let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghijklmnopqrstuvwxyz'

function generateUserId (length) {
    let seed = ''
    for (let i = 0; i < length; i++) {
        seed += chars[Math.floor(Math.random() * chars.length)]
    }
    return seed
}


let userId
if (localStorage) {
    userId = localStorage.getItem('userId')
}

if (!userId) {
    userId = generateUserId(10) //FIXME use random lib ? warning - it does not build
    if (localStorage) {
        localStorage.setItem('userId', userId)
    }
}


let lastCell
let lastMovedAt
let moveIntervals = []




function registerPlayerMove (targetCell) {
    lastCell = {
        x: targetCell.x,
        y: targetCell.y
    }
    let now = Date.now()

    let interval = now - lastMovedAt
    moveIntervals.push(interval)

    lastMovedAt = now
}


function initGoogleAnalytics () {
    if (config.googleId) {
        googleAnalytics.init(config.googleId)
    }
}


let currentChallengeId
function challengeStarted (challengeData) {
    if (config.googleId) {
        googleAnalytics.emit('Level Started', {
            event_category: 'Level',
            event_label: challengeData.id
        })
    }

    lastMovedAt = Date.now()
    moveIntervals.length = 0
    currentChallengeId = challengeData.id
}


function sendChallengeCompleted () {
    sendStats({
        done: Object.keys(challengesNavigator.doneSteps).length,
        win: true,
        challengeId: currentChallengeId,
        moveIntervals
    })
}


function sendWrongWayTaken () {
    sendStats({
        done: Object.keys(challengesNavigator.doneSteps).length,
        win: false,
        challengeId: currentChallengeId,
        moveIntervals,
        lastCell
    })
    moveIntervals.length = 0
}

function challengeWin (challenge) {
    if (config.googleId) {
        googleAnalytics.emit('Level Won', {
            event_category: 'Level',
            event_label: challenge.id
        })
    }
}



function challengeLose (challengeId, step) {
    if (config.googleId) {
        googleAnalytics.emit('Lost Step', {
            event_category: 'Level',
            event_label: challengeId,
            step
        })
    }
}



function gameEnded () {
    if (config.googleId) {
        googleAnalytics.emit('Game Ended', {
            event_category: 'Game'
        })
    }
}



let collectUrl = developmentEnvironment ? config.localUrl : config.productionUrl

function sendStats (stats) {
    stats.userId = userId
    if (collectUrl) {
        $.post(collectUrl, {stats: JSON.stringify(stats)})
    }
}


initGoogleAnalytics()

